import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Person from "../assets/img/account_circle_black_24dp.svg";
import Feedback from "../assets/img/rate_review_FILL0_wght400_GRAD0_opsz24.svg";
import secureLocalStorage from "react-secure-storage";
import KEYS from "../env/env";
import { config } from "../utils/config";
import { dataURLToBlob, doRequest, userID } from "../utils/helper";
import FeedbackScreenShotModal from "./FeedbackScreenShotModal";
import FeedbackOffCanvas from "./FeedbackOffCanvas";
import { toast } from "react-toastify";
import { trackAnalyticsEvent } from "../utils/analytics";

function DesignSidebar({ isOpen }) {
  const userLoginDetails = localStorage.getItem(config.USER_LOGIN_DETAILS);
  const userLoginDetailsParsed = userLoginDetails ? JSON.parse(userLoginDetails) : {};

  const [feedbackLoading, setFeedbackLoading] = useState(false);
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [showScreenShot, setShowScreenShot] = useState(false);
  const [description, setDescription] = useState("");
  const [feedbackType, setFeedbackType] = useState("feedback");
  const [previewSrc, setPreviewSrc] = useState(null);


  const handleClose = () => setShow(false);
  const handleShow = () => {
    trackAnalyticsEvent("design_sidebar_feedback_open", {
      source: "design_sidebar",
    });
    setShow(true);
  };

  const handleLogout = () => {
    trackAnalyticsEvent("design_sidebar_account_logout", {
      source: "design_sidebar",
    });
    // secureLocalStorage.removeItem("Login");
    localStorage.removeItem("Login");
    // secureLocalStorage.removeItem(config.USER_LOGIN_DETAILS);
    localStorage.removeItem(config.USER_LOGIN_DETAILS);
    localStorage.clear();
    navigate("/");
  };

  const trackAccountClick = (route, section) => {
    trackAnalyticsEvent("design_sidebar_account_menu_click", {
      route,
      section,
    });
  };

  const handleFeedbackType = (type) => {
    setFeedbackType(type);
  };


  const handelScreenShotShow = async (isFirst) => {
    try {
      if (isFirst === true) {
        handleClose();
      }
      const stream = await navigator.mediaDevices.getDisplayMedia({
        preferCurrentTab: true,
      });

      const video = document.createElement('video');

      video.addEventListener('loadedmetadata', () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        // passing video width & height as canvas width & height
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        video.play(); // playing the video so the drawn image won't be black or blank
        // drawing an image of the captured video stream
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        stream.getVideoTracks()[0].stop(); // terminating first video track of the stream

        // passing canvas data url as screenshot preview src
        setPreviewSrc(canvas.toDataURL());
        // let preview = canvas.toDataURL();
        //setShowPreview(true);
      });
      video.srcObject = stream; // passing capture stream data as video source object

      setShow(true);
    } catch (error) {
      // if image couldn't capture by any reason, then alert the msg
      alert('Failed to capture screenshot!');
    }
  };

  // const sendFeedbackApi = async () => {
  //   setFeedbackLoading(true);
  //   const blobData = dataURLToBlob(previewSrc);
  //   const file = new File([blobData], `feedback_${Date.now()}.png`, { type: "image/png" });

  //   const data1 = new FormData();
  //   data1.append("file", file);
  //   data1.append("folder_name", "screenshot_images");
  //   data1.append("category", feedbackType);
  //   data1.append("status", "0");

  //   try {
  //     const response = await fetch(`${KEYS.apiPath}file/save`, { method: "POST", body: data1 });
  //     const data = await response.json();
  //     const screenshot = data?.resultFlag === 1 ? `${config.s3BaseUrl}/${data.response.url}` : "";

  //     const feedbackData = {
  //       comment: description,
  //       user_id: userID(),
  //       source: "cms",
  //       status: "active",
  //       type: feedbackType,
  //       image: screenshot,
  //     };
  //     await doRequest(feedbackData, "POST", "feedback/save");

  //     toast.success("Feedback submitted successfully");
  //     setShow(false);
  //     setFeedbackLoading(false);
  //   } catch (error) {
  //     console.error("Error uploading feedback:", error);
  //     setFeedbackLoading(false);
  //   }
  // };


  const sendFeedbackApi = async () => {

    const base64 = previewSrc.split(',')[1];

    setFeedbackLoading(true);
    let screenshot = '';
    var file;
    const blobData = dataURLToBlob(previewSrc);

    file = new File([blobData], `feedback_${Date.now()}.png`, {
      lastModified: new Date().getTime(),
      type: 'image/png',
    });

    const data1 = new FormData();
    data1.append('base64', base64);
    data1.append('folder', 'screenshot_images');
    data1.append('fileName', `feedback_${Date.now()}.png`);
    data1.append('mimeType', 'image/png');
    // data1.append('category', feedbackType);
    // data1.append('status', '0'); 

    // const filePayload = {
    // 	base64: base64,
    // 	folder: 'screenshot_images',
    // 	fileName: `feedback_${Date.now()}.png`,
    // 	mimeType: 'image/png',
    // }

    const requestOptions = {
      method: 'POST',
      // body: JSON.stringify(filePayload),
      body: data1,
      redirect: 'follow',
      headers: {
        // 'Authorization': `Bearer ${secureLocalStorage.getItem('Login')}`
        'Authorization': `Bearer ${localStorage.getItem('Login')}`
      }
    };

    try {
      // let response = await fetch(`${KEYS.apiPath}file/save`, requestOptions);
      let response = await fetch(`${KEYS.apiPath}file/save`, requestOptions);
      let data = await response.json();
      if (data && +data?.resultFlag === 1) {
        let imgUrl = data?.response?.url;
        screenshot = config.s3BaseUrl + '/' + imgUrl;
      } else {
      }
    } catch (error) { }

    let data = {
      comment: description,
      user_id: userID(),
      source: 'cms',
      status: 'active',
      type: feedbackType,
      image: screenshot,
    };

    let res = await doRequest(data, 'POST', 'feedback/save');
    setFeedbackLoading(false);
    toast.success("Feedback submitted successfully");
    setShow(false);
    if (+res?.result === 1) {
    }
  };



  return (
    <>
      <div className={`sidemenu ${isOpen ? "sidemenuopen" : "sidemenuopen2"}`}>
        <div className="text-center">
          <ul className="nav nav-pills flex-column user_profile">
            <li className="nav-item">
              <div className="dropup">
                <button type="button" className="dropdown-toggle" data-bs-toggle="dropdown">
                  <div className="user_profile_img">
                    <img src={userLoginDetailsParsed.user_image || Person} alt="User" className="user_image_shape" />
                  </div>
                  {/* <h5>{userLoginDetailsParsed.first_name || "User"}</h5> */}
                  <h5>
                  {userLoginDetailsParsed?.first_name
											? userLoginDetailsParsed.first_name.length > 10
											? `${userLoginDetailsParsed.first_name.slice(0, 8)}…`
											: userLoginDetailsParsed.first_name
											: "User"}
										</h5>
                </button>
                <ul className="dropdown-menu dropmenu_cust">
                  <li><Link to="/profile" className="dropdown-item" onClick={() => trackAccountClick("/profile", "my_profile")}>
                    <img
                      src={'/assets/images/myprofile.svg'}
                      alt=''
                      className=''
                    />{' '}
                    My Profile</Link></li>
                  <li><Link to="/sizes" className="dropdown-item" onClick={() => trackAccountClick("/sizes", "change_size")}>
                    <img
                      src={'/assets/images/size-setting.svg'}
                      alt=''
                      className=''
                    />
                    Change Size</Link></li>
                  <li><Link to="/billing-history" className="dropdown-item" onClick={() => trackAccountClick("/billing-history", "billing_history")}>
                    <img
                      src={'/assets/images/billinghistory.svg'}
                      alt=''
                      className=''
                    />
                    Billing History</Link></li>
                  <li><Link to="/plans" className="dropdown-item" onClick={() => trackAccountClick("/plans", "plans")}>
                    <img
                      src={'/assets/images/variantdrop.svg'}
                      alt=''
                      className=''
                    />
                    Teedex Plans</Link></li>
                  <li onClick={handleLogout} className="logout_brd">
                    <Link className="dropdown-item">
                      <img
                        src={'/assets/images/logout.svg'}
                        alt=''
                        className=''
                      />
                      Logout</Link>
                  </li>
                </ul>
              </div>
            </li>
            <li className="nav-item">
              <Link to="#" className="leavefed_modal" onClick={handleShow}>
                <img src={Feedback} alt="Feedback" /> <h5>Leave<br />Feedback</h5>
              </Link>
            </li>
          </ul>
        </div>
      </div>


      {show && (
        <FeedbackOffCanvas
          previewSrc={previewSrc}
          feedbackType={feedbackType}
          description={description}
          setDescription={setDescription}
          sendFeedbackApi={sendFeedbackApi}
          handleClose={handleClose}
          show={show}
          loading={feedbackLoading}
          key={1}
          placement={'end'}
          name={'end'}
          handleFeedbackType={handleFeedbackType}
          handelScreenShotShow={handelScreenShotShow}

        />
      )}
      {showScreenShot && (
        <FeedbackScreenShotModal handelScreenShotHide={() => setShowScreenShot(false)} showScreenShot={showScreenShot} />
      )}
    </>
  );
}

export default DesignSidebar;
